import api from "../api";

export default class DiscountsApi {
  getDiscounts() {
    return api.get("/users/discounts");
  }
  getHighlightsDiscountsId() {
    return api.get("/users/discounts/highlights");
  }
}
